import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCountingLines, type UpdateCountingLineDatum } from "../api/update-counting-lines";
import { updateIntervalZones, type UpdateIntervalZoneDatum } from "../api/update-interval-zones";
import { generateKeys, type GenerateKeysItem } from "../api/generate-keys";
import { ANALYSIS_CONFIGS_QUERY_KEY } from "./use-analysis-configs";

export function useUpdateCountingLines(branchUid: string, versionId?: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dataToUpdate: UpdateCountingLineDatum[]) =>
      updateCountingLines(branchUid, versionId, dataToUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ANALYSIS_CONFIGS_QUERY_KEY, branchUid, versionId],
      });
    },
  });
}

/**
 * Key 자동 입력 — 서버에 저장하지 않고 제안만 받는다(쿼리 무효화 없음).
 * 결과는 호출부에서 localConfigs 의 pending 값으로 채운다.
 */
export function useGenerateKeys(branchUid: string) {
  return useMutation({
    mutationFn: (items: GenerateKeysItem[]) => generateKeys(branchUid, items),
  });
}

export function useUpdateIntervalZones(branchUid: string, versionId?: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dataToUpdate: UpdateIntervalZoneDatum[]) =>
      updateIntervalZones(branchUid, versionId, dataToUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ANALYSIS_CONFIGS_QUERY_KEY, branchUid, versionId],
      });
    },
  });
}
